import { z } from 'zod';

export const SUGGESTED_CATEGORIES = [
  'Venue',
  'Catering',
  'Photography',
  'Videography',
  'Florals',
  'DJ/Music',
  'Rentals',
  'Cake/Dessert',
  'Stationery',
  'Attire',
  'Hair & Makeup',
  'Transportation',
  'Favors',
  'Decor',
  'Officiant',
  'Planning/Coordination',
] as const;

export const createProjectSchema = z.object({
  name: z.string().min(1, 'Project name is required').max(255),
  person1Name: z.string().max(255).nullable().optional(),
  person1Email: z.string().email('Invalid email').max(255).nullable().optional(),
  person1Phone: z.string().max(50).nullable().optional(),
  person2Name: z.string().max(255).nullable().optional(),
  person2Email: z.string().email('Invalid email').max(255).nullable().optional(),
  person2Phone: z.string().max(50).nullable().optional(),
  weddingDate: z.string().date('Invalid date').nullable().optional(),
  guestCount: z.number().int().min(1, 'Must be at least 1').nullable().optional(),
  venueName: z.string().max(255).nullable().optional(),
  weddingTime: z.string().max(50).nullable().optional(),
  websiteUrl: z.string().url('Invalid URL').max(500).nullable().optional(),
  pinterestUrl: z.string().url('Invalid URL').max(500).nullable().optional(),
});

export const updateProjectSchema = z.object({
  name: z.string().min(1, 'Project name is required').max(255).optional(),
  person1Name: z.string().max(255).nullable().optional(),
  person1Email: z.string().email('Invalid email').max(255).nullable().optional(),
  person1Phone: z.string().max(50).nullable().optional(),
  person2Name: z.string().max(255).nullable().optional(),
  person2Email: z.string().email('Invalid email').max(255).nullable().optional(),
  person2Phone: z.string().max(50).nullable().optional(),
  weddingDate: z.string().date('Invalid date').nullable().optional(),
  guestCount: z.number().int().min(1, 'Must be at least 1').nullable().optional(),
  venueName: z.string().max(255).nullable().optional(),
  weddingTime: z.string().max(50).nullable().optional(),
  websiteUrl: z.string().url('Invalid URL').max(500).nullable().optional(),
  pinterestUrl: z.string().url('Invalid URL').max(500).nullable().optional(),
  photoUrl: z.string().nullable().optional(),
});

export const createCategorySchema = z.object({
  projectId: z.string().uuid('Invalid project ID'),
  name: z.string().min(1, 'Category name is required').max(255),
  estimatedCost: z.number().int().min(0).nullable().optional(),
  sortOrder: z.number().int().min(0).optional().default(0),
});

export const updateCategorySchema = z.object({
  name: z.string().min(1, 'Category name is required').max(255).optional(),
  estimatedCost: z.number().int().min(0).nullable().optional(),
  sortOrder: z.number().int().min(0).optional(),
});

export type CreateProjectInput = z.input<typeof createProjectSchema>;
export type UpdateProjectInput = z.infer<typeof updateProjectSchema>;
export type CreateCategoryInput = z.infer<typeof createCategorySchema>;
export type UpdateCategoryInput = z.infer<typeof updateCategorySchema>;
